import {RefSearcher} from './RefSearcher';
import {Either, error} from '../fp';

export default class SubInstallRefSearcherImpl implements RefSearcher {
  async find(): Promise<Either<string, void>> {
    return error(undefined);
  }
}
